import { useFrame, useLoader } from "@react-three/fiber";
import { TextureLoader } from "three";
import { Sphere } from "@react-three/drei";
import React, { useRef } from "react";

export const Earth = () => {
    const texture = useLoader(TextureLoader, "/earthtex-low-res.jpg"); 
    const mesh = useRef();
  
    useFrame(({ clock }) => {
      if (mesh.current) {
        mesh.current.rotation.y = clock.getElapsedTime() / 20; 
      }
    });
  
    return (
      <Sphere args={[200, 100, 100]} ref={mesh}>
        <meshStandardMaterial map={texture} />
      </Sphere>
    );
};
